import { useQuery } from '@apollo/client'

import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { FIND_ALL_USER_REWARDS_BY_ADMIN } from 'queries/users'
import {
  findAllUserRewardByAdmin,
  findAllUserRewardByAdminVariables,
} from '__generatedTypes__/findAllUserRewardByAdmin'
import {
  findAllPlatforms,
  findAllPlatforms_findAllPlatforms_items as Platform,
  findAllPlatformsVariables,
} from '__generatedTypes__/findAllPlatforms'
import { GET_PLATFORMS } from 'queries/common'
import { RewardTypeEnum } from '__generatedTypes__/globalTypes'
import { PlatformSlug, TAKE_ALL_ITEMS_COUNT } from 'constants/consts'
import { getPlatformProductConfig } from 'pagesNew/Products/platformConfig'

export const isRewardHidden = (rewardType: RewardTypeEnum, platform: PlatformSlug) => {
  const config = getPlatformProductConfig(platform)

  if (!config) {
    return true
  }

  if (rewardType === RewardTypeEnum.PauseToken) {
    return !config.pauseTokens
  }
  if (rewardType === RewardTypeEnum.Extension) {
    return !config.regularExtensions
  }
  if (rewardType === RewardTypeEnum.FreeMissedStreak && platform === PlatformSlug.CARSBooster) {
    return true
  }
  return false
}

export function useItems(userId: string) {
  const { platform: platformSlug } = useParams()

  const [selectedPlatform, setSelectedPlatform] = useState<Platform | null>(null)

  const { data: platformsData, loading: platformsLoading } = useQuery<findAllPlatforms, findAllPlatformsVariables>(
    GET_PLATFORMS,
    {
      variables: { query: { take: TAKE_ALL_ITEMS_COUNT } },
      onCompleted: (data) => {
        const platforms = data?.findAllPlatforms.items
        const platform = platforms?.find((p) => p.slug === platformSlug) ?? platforms?.[0]

        if (platform) {
          setSelectedPlatform(platform)
        }
      },
    }
  )

  const {
    data: itemsData,
    loading: itemsLoading,
    refetch: refetchItems,
  } = useQuery<findAllUserRewardByAdmin, findAllUserRewardByAdminVariables>(FIND_ALL_USER_REWARDS_BY_ADMIN, {
    fetchPolicy: 'cache-and-network',
    variables: {
      query: {
        where: {
          reward: { platform: { id: selectedPlatform?.id } },
        },
      },
      user: {
        id: userId,
      },
    },
    skip: !selectedPlatform,
  })

  return {
    items:
      itemsData?.findAllUserRewardByAdmin.items.filter(
        ({ reward }) => !isRewardHidden(reward.type, selectedPlatform?.slug as PlatformSlug)
      ) || [],
    itemsLoading: itemsLoading && !itemsData?.findAllUserRewardByAdmin,
    platforms: platformsData?.findAllPlatforms.items || [],
    platformsLoading,
    selectedPlatform,
    setSelectedPlatform,
    refetchItems,
  }
}
